import React, { useState, useEffect, useCallback } from "react";
import DefaultLayout from "../../components/DefaultLayout";
import CurrentMonthTransfersTable from "../../components/Tables/CurrentMonthTransfersTable";
import axiosInstance from "../../utils/axiosInstance";

const CurrentMonthTransfer = () => {
  const [transfers, setTransfers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransfers = transfers ? transfers.slice(indexOfFirstItem, indexOfLastItem) : [];

  const fetchTransfers = useCallback(async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get("/wallet/current-month-transfers", {
        params: {
          page,
          limit: itemsPerPage
        }
      });

      if (response?.data?.success) {
        // Ensure we always have an array
        const transfersData = Array.isArray(response.data.data) 
          ? response.data.data 
          : [];
        setTransfers(transfersData);
        setTotalPages(response.data.totalPages || 1);
        setTotalCount(response.data.totalCount || transfersData.length);
        setCurrentPage(page);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch transfers');
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch transfers');
      console.error('Error fetching transfers:', err);
    } finally {
      setIsLoading(false);
    }
  }, [itemsPerPage]);
  useEffect(() => {
    fetchTransfers();
  }, [fetchTransfers]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchTransfers(page);
    }
  };

  const handleItemsPerPageChange = (value) => {
    setCurrentPage(1);
    fetchTransfers(1);
  };

  if (isLoading) {
    return (
      <DefaultLayout>
        <div className="w-full h-full px-4 py-6 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
        </div>
      </DefaultLayout>
    );
  }

  if (error) {
    return (
      <DefaultLayout>
        <div className="w-full h-full px-4 py-6">
          <div className="bg-red-500/10 text-red-500 p-4 rounded-lg">
            <p className="text-center">{error}</p>
          </div>
        </div>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout>
      <div className="w-full h-full px-6 py-2">
        <div className="p-2 mb-2">
          <h1 className="text-2xl font-semibold text-white">Current Month Transfers</h1>
          <p className="text-sm text-white/80 mt-1">View all current month transfer transactions</p>
        </div>
        <CurrentMonthTransfersTable
          transfers={currentTransfers}
          prevPage={currentPage > 1 ? () => handlePageChange(currentPage - 1) : null}
          nextPage={currentPage < totalPages ? () => handlePageChange(currentPage + 1) : null}
          paginate={handlePageChange}
          currentPage={currentPage}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          itemsPerPage={itemsPerPage}
          isFetching={isLoading}
          handleItemsPerPageChange={handleItemsPerPageChange}
          totalCount={totalCount}
        />
      </div>
    </DefaultLayout>
  );
};

export default CurrentMonthTransfer;
